module.exports = "div.no-edit {\n    min-height: 40px;\n    background-color: #e9ecef;\n    opacity: 1;\n    background-clip: padding-box;\n    border: 1px solid #ced4da;\n    border-radius: .25rem;\n    padding: .375rem .75rem;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/articles/version/version.component.css
// module id = ./src/app/articles/version/version.component.css
// module chunks = main